exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-family: \"Quicksand\", sans-serif;\n}", ""]);

// exports
